import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'app/appStore';
import {
	clearValues,
	ESourceTypes,
	EVerificationOpenForm,
	IArbitrageForm,
	IBloggerForm,
	IWebsiteForm,
	setAllBloggerUrls,
	setArbitrationValues,
	setBloggerUrls,
	setBloggerValues,
	setType,
	setVerificationOpenFrom,
	setWebsiteValues,
} from 'entities/Source';

export const useSourceSlice = () => {
	const dispatch = useDispatch();

	return {
		...useSelector((s: RootState) => s.sourceSlice),
		setVerificationOpenFrom: (from: EVerificationOpenForm) => dispatch(setVerificationOpenFrom(from)),
		setType: (value: ESourceTypes) => dispatch(setType(value)),
		setWebsiteValues: (values: IWebsiteForm) => dispatch(setWebsiteValues(values)),
		setBloggerValues: (values: IBloggerForm) => dispatch(setBloggerValues(values)),
		setBloggerUrls: (values: { key: string; value: string[] }) => dispatch(setBloggerUrls(values)),
		setAllBloggerUrls: (values: Record<string, string[]>) => dispatch(setAllBloggerUrls(values)),
		setArbitrationValues: (values: IArbitrageForm) => dispatch(setArbitrationValues(values)),
		clearValues: () => dispatch(clearValues()),
	};
};
